import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { PaginatedCompanyContacts } from './PaginatedCompanyContacts.tsx';
import AddContactToCompanyModal from './AddContactToCompanyModal.tsx';

const CompanyContacts: React.FC = () => {
  const company = useRecordContext();
  if (!company?.id) return null;

  return (
    <Grid container spacing={2} mb={2}>
      <Grid size={{ xs: 12 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            Contacts
          </Typography>
          <AddContactToCompanyModal />
        </Box>
        <PaginatedCompanyContacts companyId={company.id as number} />
      </Grid>
    </Grid>
  );
};

export default CompanyContacts;
